export enum TransportSelectionMode {
  MANDATORY = 'MANDATORY',
  OPTIONAL = 'OPTIONAL',
}
